/* eslint-disable */

import {
	format as formatFns,
	formatDistanceToNow as formatDistanceToNowFns,
	formatDistanceToNowStrict as formatDistanceToNowStrictFns,
	addBusinessDays as addBusinessDaysFns,
	isWeekend
} from 'date-fns';
import { fr } from 'date-fns/locale';

export const format = (date, formatStr = 'PP' ) => formatFns(date, formatStr, { locale: fr });
// export const addBusinessDays = (date, amount) => addBusinessDaysFns(date, amount, { locale: fr });


export const addBusinessDays = (d, n) => {
	// while the number of days to add is greater than 0
	while (n > 0) {
		// set the date forward one day
		d.setDate(d.getDate() + 1);
		// if the date is not a weekend and not a holiday, decrement n
		if(!isWeekend(d)) {
			n--;
		}
	}

	return d;
}

export const formatDistanceToNow = (date, addSuffix = true) => formatDistanceToNowFns(date, {
	addSuffix,
	locale: fr
});

export const formatDistanceToNowStrict = (date, addSuffix = true) => formatDistanceToNowStrictFns(date, {
	addSuffix,
	locale: fr,
	unit: 'day',
	roundingMethod: 'ceil'
});
